import { render, staticRenderFns } from "./QuatiLogin.vue?vue&type=template&id=94f9596e"
import script from "./QuatiLogin.vue?vue&type=script&lang=js"
export * from "./QuatiLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports